var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "card-header",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "el-form",
                {
                  staticClass: "search-form",
                  attrs: { inline: true, model: _vm.searchForm, size: "small" },
                  nativeOn: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "小程序名称" } },
                    [
                      _c("el-input", {
                        attrs: {
                          clearable: "",
                          placeholder: "请输入小程序名称",
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleSearch($event)
                          },
                        },
                        model: {
                          value: _vm.searchForm.keyword,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.searchForm,
                              "keyword",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "searchForm.keyword",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "AppID" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", placeholder: "请输入AppID" },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleSearch($event)
                          },
                        },
                        model: {
                          value: _vm.searchForm.appId,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.searchForm,
                              "appId",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "searchForm.appId",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "归属客户" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            remote: "",
                            clearable: "",
                            placeholder: "请选择归属客户",
                            "remote-method": _vm.loadCustomerOptions,
                          },
                          on: { "visible-change": _vm.handleCustomerVisible },
                          model: {
                            value: _vm.searchForm.customerId,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "customerId", $$v)
                            },
                            expression: "searchForm.customerId",
                          },
                        },
                        _vm._l(_vm.customerOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleSearch },
                        },
                        [_vm._v("搜索")]
                      ),
                      _vm._v(" "),
                      _c("el-button", { on: { click: _vm.resetSearch } }, [
                        _vm._v("重置"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "header-actions" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "has-permi",
                          rawName: "v-has-permi",
                          value: ["admin:miniapp:release:upload"],
                          expression: "['admin:miniapp:release:upload']",
                        },
                      ],
                      attrs: {
                        type: "primary",
                        size: "small",
                        icon: "el-icon-upload2",
                      },
                      on: { click: _vm.openBatchUpload },
                    },
                    [_vm._v("统一上传")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", icon: "el-icon-time" },
                      on: { click: _vm.openBatchHistory },
                    },
                    [_vm._v("统一上传记录")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: { data: _vm.tableData.list, border: "", size: "mini" },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "ID", width: "65" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Logo", width: "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-image", {
                          staticClass: "app-logo",
                          attrs: {
                            fit: "cover",
                            src: scope.row.appLogo,
                            "preview-src-list": scope.row.appLogo
                              ? [scope.row.appLogo]
                              : [],
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "appName",
                  label: "小程序名称",
                  "min-width": "170",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "customerName",
                  label: "归属客户",
                  "min-width": "170",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "originalId",
                  label: "原始ID",
                  "min-width": "160",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "appId",
                  label: "AppID",
                  "min-width": "165",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "第三方平台授权",
                  width: "170",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "status-cell" },
                          [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: scope.row.thirdPartyAuthorized
                                    ? "success"
                                    : "info",
                                  size: "mini",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      scope.row.thirdPartyAuthorized
                                        ? "已授权"
                                        : "未授权"
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            scope.row.thirdPartyAuthorized
                              ? _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: _vm.getAuthorizedPlatformNames(
                                        scope.row
                                      ),
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "platform-name" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getAuthorizedPlatformNames(
                                              scope.row
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "当前体验版", width: "125", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.experienceVersion
                          ? _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: _vm.getExperienceTip(scope.row),
                                  placement: "top",
                                },
                              },
                              [
                                _c(
                                  "el-tag",
                                  { attrs: { type: "success", size: "mini" } },
                                  [_vm._v(_vm._s(scope.row.experienceVersion))]
                                ),
                              ],
                              1
                            )
                          : _c("span", { staticClass: "empty-status" }, [
                              _vm._v(
                                _vm._s(
                                  scope.row.experienceSyncTime
                                    ? "暂无"
                                    : "未同步"
                                )
                              ),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "审核状态", width: "125", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              disabled: !_vm.getAuditTip(scope.row),
                              content: _vm.getAuditTip(scope.row),
                              placement: "top",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "status-cell" },
                              [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type: _vm.getAuditStatus(
                                        scope.row.auditStatus
                                      ).type,
                                      size: "mini",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.getAuditStatus(
                                            scope.row.auditStatus
                                          ).label
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                scope.row.auditVersionNo
                                  ? _c(
                                      "span",
                                      { staticClass: "status-version" },
                                      [_vm._v(_vm._s(scope.row.auditVersionNo))]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "发布状态", width: "125", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              disabled: !scope.row.publishErrorMessage,
                              content: scope.row.publishErrorMessage || "",
                              placement: "top",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "status-cell" },
                              [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type: _vm.getPublishStatus(
                                        scope.row.publishStatus
                                      ).type,
                                      size: "mini",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.getPublishStatus(
                                            scope.row.publishStatus
                                          ).label
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                scope.row.publishVersionNo
                                  ? _c(
                                      "span",
                                      { staticClass: "status-version" },
                                      [
                                        _vm._v(
                                          _vm._s(scope.row.publishVersionNo)
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  width: "110",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.openReleaseManage(scope.row)
                              },
                            },
                          },
                          [_vm._v("版本管理")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            staticClass: "table-pagination",
            attrs: {
              "page-sizes": [20, 40, 60, 80],
              "page-size": _vm.page.limit,
              "current-page": _vm.page.page,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.tableData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "统一上传记录",
            visible: _vm.batchHistoryVisible,
            width: "1080px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.batchHistoryVisible = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.batchLoading,
                  expression: "batchLoading",
                },
              ],
              attrs: { data: _vm.batchData.list, border: "", size: "mini" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "batchNo",
                  label: "批次号",
                  "min-width": "235",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "versionNo", label: "版本号", width: "100" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "versionDesc",
                  label: "版本描述",
                  "min-width": "180",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "CI机器人", width: "90", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            scope.row.robotNo === 0 ? "多个" : scope.row.robotNo
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "任务数", width: "190" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          共 " +
                            _vm._s(scope.row.totalCount) +
                            " / 成功 " +
                            _vm._s(scope.row.successCount) +
                            " / 失败 " +
                            _vm._s(scope.row.failedCount) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "状态", width: "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getBatchStatus(scope.row.batchStatus)
                                .type,
                              size: "mini",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.getBatchStatus(scope.row.batchStatus)
                                    .label
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "operatorName", label: "操作人", width: "100" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "创建时间", width: "155" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          _vm._s(_vm.formatDateTime(scope.row.createTime))
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  width: "80",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.openBatchProgress(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("查看进度")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            staticClass: "table-pagination",
            attrs: {
              "page-size": _vm.batchPage.limit,
              "current-page": _vm.batchPage.page,
              layout: "total, prev, pager, next",
              total: _vm.batchData.total,
            },
            on: { "current-change": _vm.handleBatchPageChange },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("MiniProgramReleaseManage", {
        ref: "releaseManage",
        on: { closed: _vm.loadList },
      }),
      _vm._v(" "),
      _c("BatchUploadDialog", {
        ref: "batchUpload",
        on: { created: _vm.handleBatchCreated },
      }),
      _vm._v(" "),
      _c("BatchUploadProgress", {
        ref: "batchProgress",
        on: { finished: _vm.loadBatchList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }